import { useQuery } from "@tanstack/react-query";
import usersService from "services/usersService";

export const useGetUser = () => {
    return useQuery({
        queryKey: ['getUser'],
        queryFn: async () => {
            const { data } = await usersService.me()
            return data
        },
        refetchOnWindowFocus: false,
    })
}